export function wrapQR(img: string) {
    return `<div style='width:100%;height:100%;aspect-ratio:auto && 1/1; display:flex;align-items:center;justify-content:center;'>${img}</div>`;
}
